// 课程管理
export default [
  {
    path: "/courseManage",
    name: "courseManage",
    meta: { title: "课程管理" },
    component: () => import("../views/courseManage/index"),
    children: [
      {
        path: "/courseManage/courseList",
        meta: { title: "课程列表", isMenu: true },
        component: () => import("../views/courseManage/courseList"),
      },
      {
        path: "/courseManage/detail/courseInfo",
        meta: { title: "课程详情", isMenu: true },
        component: () => import("../views/courseManage/detail/courseInfo"),
      },
      {
        path: "/courseManage/detail/applyCourse",
        meta: { title: "新增课程", isMenu: true },
        component: () => import("../views/courseManage/detail/applyCourse"),
      },
      {
        path: "/courseManage/detail/lesson",
        meta: { title: "课时管理", isMenu: true },
        component: () => import("../views/courseManage/detail/lesson"),
      },
      {
        path: "/courseManage/detail/buyerList",
        meta: { title: "已购用户", isMenu: true },
        component: () => import("../views/courseManage/detail/buyerList"),
      },
      {
        path: "/courseManage/detail/afterClassQA",
        meta: { title: "课后问答", isMenu: true },
        component: () => import("../views/courseManage/detail/afterClassQA"),
      },
      {
        path: "/courseManage/categoryList",
        meta: { title: "课程分类", isMenu: true },
        component: () => import("../views/courseManage/categoryList"),
      },
    ],
  },
]
